import { Injectable } from '@angular/core';
import { BrokerService } from './broker.service';
import {
  EvidenteRequest,
  EvidenteResponse,
  ValidateEvidente,
  Preguntas
} from '../models/validate.model';
import { SesionService } from './sesion.service';
import { LoadingService } from './loading.service';
import { ModalService } from './modal.service';
import { ValidateOtp } from '../models/validate.model';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { UtilitiesService } from './utilities.service';

declare var $: any;
declare var require: any;
const sha256 = require('js-sha256');

@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  validar = false;
  evidente: any;
  enviarValidacion: ValidateEvidente;
  withEvident = false;
  baseOtp: any;
  otp: any;
  origin: any;
  complete: any;
  registerData: any;
  modeloLogin: any;
  private singleExecutionSubscription: Subscription = new Subscription;

  constructor(
    private broker: BrokerService,
    private sesion: SesionService,
    private loading: LoadingService,
    private modal: ModalService,
    public router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private utilities: UtilitiesService
  ) {

    this.enviarValidacion = {
      identificacion: '',
      tipoIdentificacion: '',
      idCuestionario: '',
      regCuestionario: '',
      respuestas: [],
      captcha: ''
    }
  }

  initRecovery() {
    this.evidente = null;
    this.validar = false;
  }

  evidenteNoPermitido(resultado: any) {
    this.loading.close();
    this.validar = false;
    this.withEvident = false;

    switch (resultado) {
      case '10':
      case '11':
      case '12':
        this.modal.open(
          'Error generando el cuestionario',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Has superado tu límite de intentos permitidos, por favor vuelve a intentarlo nuevamente mañana.</span></p>',
          'assets/images/backgrounds/No_data.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
      default:
        this.modal.open(
          'Por favor verifica tus datos.',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Los datos que ingresaste no coinciden con los que tenemos en nuestra base de datos</span></p>',
          'assets/images/backgrounds/No_coincide.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
    }
  }

  evidenteFallido(origin: string) {
    this.withEvident = false;
    this.loading.close();
    this.validar = false;
    this.modal.open(
      'Por favor verifica los datos ingresados',
      // tslint:disable-next-line: max-line-length
      '<p>Hay un error en la información proporcionada.</p>',
      'assets/images/icons/bad.svg',
      true,
      '',
      'Reintentar',
      'modal-error'
    );
    this.sesion.navigateToRoute(origin);
  }

  redirectOrigin() {
    switch (this.sesion.product) {
      case 'midc':
        window.location.href = this.utilities.getUrlProduct('midc') + this.origin;
        break;
    }
  }

  redirectComplete(autogestion: boolean) {
    if (autogestion) {
      this.router.navigate(['/login'], { queryParams: { product: this.sesion.product, auto: 1 } });
    }
    else {
      window.location.href = this.utilities.getUrlProduct('midc') + this.complete;
    }
  }

  otpFallido() {
    this.otp = null;
    this.loading.close();
    this.modal.open(
      'Por favor verifica los datos ingresadas',
      // tslint:disable-next-line: max-line-length
      '<p>Hay un error en la información proporcionada.</p>',
      'assets/images/icons/bad.svg',
      true,
      '',
      'Reintentar',
      'modal-error'
    );
  }

  //Evidente Recuperar Contraseña
  passRecovery(solicitud: EvidenteRequest) {
    this.initRecovery();

    this.loading.open('Por favor espera un momento ...', 'Estamos validando tus datos');
    this.broker.passRecovery(solicitud).subscribe((resp: any) => {
      if (resp.resultado === '01') {
        this.preguntasEvidente(solicitud, resp);
      } else {
        this.evidenteNoPermitido(resp.resultado);
      }
    }, (error) => {
      this.evidenteNoPermitido('');
    });
  }

  registroCuestionarioOTP(solicitudPreguntas: Preguntas) {
    this.broker.questions(solicitudPreguntas).subscribe((resp: any) => {
      if (resp.resultado === '01') {
        const solicitudEvidente = {
          identificacion: solicitudPreguntas.identificacion,
          tipoIdentificacion: solicitudPreguntas.tipoId,
          primerApellido: '',
          nombres: '',
          fechaExpedicion: '',
          captcha: ''
        }
        this.preguntasEvidente(solicitudEvidente, resp);
      } else {
        this.evidenteNoPermitido(resp.resultado);
      }
    }, (error) => {
      this.evidenteNoPermitido('');
    });
  }

  preguntasEvidente(solicitud: EvidenteRequest, resp: EvidenteResponse) {
    this.loading.close();
    this.evidente = resp;
    this.validar = true;

    this.enviarValidacion = {
      identificacion: solicitud.identificacion,
      tipoIdentificacion: solicitud.tipoIdentificacion,
      idCuestionario: resp.id,
      regCuestionario: resp.registro,
      respuestas: [],
      captcha: ''
    };

    this.sesion.navigateToRoute('/registro/validar');
  }

  validarPassRespuestas(redirect: string, origin: string) {
    this.loading.open('Por favor espera un momento ...', 'Estamos validando las respuestas');
    this.broker.passRecoveryVerify(this.enviarValidacion).subscribe((resp: any) => {
      if (resp.aprobacion === 'true') {
        this.withEvident = true;
        this.loading.close();
        this.validar = false;
        this.sesion.navigateToRoute(redirect);
      } else {
        this.evidenteFallido(origin);
      }
    }, (error) => {
      this.evidenteFallido(origin);
    });
  }

  //OTP
  // iniciarOtp(celular: string) {
  //   this.loading.open('Por favor espera un momento ...', 'Estamos enviando un código de verificación a tu celular');
  //   this.broker.validateOTP_customer().subscribe((resp: InitOtpCustomer) => {
  //     if (resp.resultado === '1') {
  //       this.redirectComplete();
  //     } else if (resp.ResultadoGeneracion.codResultadoOTP === '4') {
  //       this.baseOtp = resp;
  //       this.enviarCodigo(celular);
  //     } else {
  //       this.otpFallido();
  //     }
  //   }, (error) => {
  //     this.otpFallido();
  //   });
  // }

  // enviarCodigo(celular: string) {
  //   const generateCode: OtpCodigoRequest = {
  //     identificacion: this.sesion.user.documento,
  //     tipoIdentificacion: this.sesion.user.tipoDocumento.toString(),
  //     regValidacion: this.baseOtp.DatosCuestionario.regValidacion,
  //     idTransaccionOTP: this.baseOtp.ResultadoGeneracion.idTransaccionOTP,
  //     numeroCelular: celular
  //   };

  //   this.broker.generateOTP(generateCode).subscribe((res: OtpCodigoResponse) => {
  //     if (res.ResultadoGeneracion.codResultadoOTP === '4') {
  //       this.otp = res;
  //       this.loading.close();
  //       this.sesion.navigateToRoute('/private/validacion/codigo');
  //     } else {
  //       this.otpFallido();
  //     }
  //   }, (error) => {
  //     this.otpFallido();
  //   });
  // }

  validarCodigo(codigo: string) {
    const generateCode: ValidateOtp = {
      identificacion: this.sesion.user.documento,
      tipoIdentificacion: this.sesion.user.tipoDocumento.toString(),
      regValidacion: this.baseOtp.DatosCuestionario.regValidacion,
      idTransaccionOTP: this.baseOtp.ResultadoGeneracion.idTransaccionOTP,
      codigoOTP: sha256(codigo)
    };

    this.broker.verifyOTP(generateCode).subscribe((res: any) => {
      if (res.resultadoValidacion === '1') {
        this.loading.close();
        if (this.otp.ResultadoGeneracion.requiereCuestionario === 'true') {
          this.evidenteOtp();
        } else {
          this.redirectComplete(false);
        }
      } else {
        this.otpFallido();
      }
    }, (error) => {
      this.otpFallido();
    });
  }

  evidenteOtp() {
    const solicitud = {
      nombres: this.sesion.user.nombre,
      primerApellido: this.sesion.user.apellido,
      identificacion: this.sesion.user.documento,
      tipoIdentificacion: this.sesion.user.tipoDocumento.toString(),
      fechaExpedicion: '1103846400000',
      captcha: ''
    };

    this.broker.questions(solicitud).subscribe((res: any) => {
      if (res.resultado === '01') {
        this.preguntasEvidenteRegistro(solicitud, res);
      } else {
        this.redirectComplete(false);
      }
    }, (error) => {
      this.redirectOrigin();
    });
  }


  //Evidente Master o II
  preguntasEvidenteRegistro(solicitud: EvidenteRequest, resp: EvidenteResponse) {
    this.loading.close();
    this.evidente = resp;
    this.validar = true;

    this.enviarValidacion = {
      identificacion: solicitud.identificacion,
      tipoIdentificacion: solicitud.tipoIdentificacion,
      idCuestionario: resp.id,
      regCuestionario: resp.registro,
      respuestas: [],
      captcha: ''
    };

    // Evidente
    this.sesion.navigateToRoute('/private/validacion/evidente');
  }

  validarRespuestas(origin: string, autogestion: boolean) {
    this.loading.open('Por favor espera un momento ...', 'Estamos validando las respuestas');

    if (autogestion) {
      this.enviarValidacion.parametro = environment.parametriaAutoGestion;
    }

    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("ValidarAutoGestion")
      .subscribe(
        (token) => {
          this.enviarValidacion.captcha = token;
          this.broker.validateQuestions_User(this.enviarValidacion).subscribe((resp: any) => {

            if (resp.aprobacion === 'true') {
              this.withEvident = true;
              this.loading.close();
              this.validar = false;
              this.redirectComplete(autogestion);
            } else {
              this.evidenteFallido(origin);
            }
          }, (error) => {
            this.evidenteFallido(origin);
          });
        },
        (error) => {
          // Error.
        }
      );
  }

  //Evidente Registro Usuario
  validarRespuestasRegistro(origin: string) {
    this.loading.open('Por favor espera un momento ...', 'Estamos validando las respuestas.');
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("CaptchaGenerateOTP")
      .subscribe(
        (token) => {
          this.enviarValidacion.captcha = token;
          this.broker.verifyQuestions(this.enviarValidacion).subscribe((resp: any) => {
            if (resp.aprobacion === 'true') {
              this.loading.close();
              this.modeloLogin.justEvidente = true;
              this.callFirstAuthnEvi(this.modeloLogin);
            } else {
              this.evidenteFallido(origin);
            }
          }, (error) => {
            this.evidenteFallido(origin);
          });
        },
        (error) => {
          // Error.
        }
      );
  }

  //Validar respuestas registro OTP
  validarRespuestasRegistroOTP(origin: string) {
    this.loading.open('Por favor espera un momento ...', 'Estamos validando las respuestas');
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("CaptchaGenerateOTP")
      .subscribe(
        (token) => {
          this.enviarValidacion.captcha = token;

          this.broker.validateQuestionsOTP(this.enviarValidacion).subscribe((resp: any) => {
            if (resp.aprobacion === 'true') {
              this.loading.close();
              this.modeloLogin.justEvidente = true;
              this.callFirstAuthnEvi(this.modeloLogin);
            } else {
              this.sesion.resetLogin = true;
              this.evidenteFallido(origin);
            }
          }, (error) => {
            this.sesion.resetLogin = true;
            this.evidenteFallido(origin);
          });
        },
        (error) => {
          // Error.
        }
      );
  }

  registerUser() {
    this.loading.open('Proceso validado con éxito', 'Terminando proceso de registro.');

    //Solo para la prueba sin evidente. Quitar después.
    //this.registerData.passEvidente = true;

    this.broker.registerUser(this.registerData).subscribe((resp: any) => {
      const login = {
        tipoDocumento: this.registerData.userOkta.profile.idType,
        documento: this.registerData.userOkta.profile.idNumber,
        password: this.registerData.userOkta.credentials.password.value,
        clientId: this.sesion.codeApp
      };
      //this.login.firstAuth(login, true);
    },
      error => {
        this.loading.close();
        if (error.status !== 409) {
          this.modal.open(
            'Registro fallido, datos no válidos. Verifica la información e intenta nuevamente.',
            '',
            'assets/images/backgrounds/No_coincide.svg',
            true,
            '/registro?product=' + this.sesion.product,
            'Regresar',
            'modal-confirm',
            undefined,
            true
          );
        } else {
          switch (error.error.status_code) {
            // Ya registrado en Okta
            case -1002:
              this.modal.open(
                '¡Ya eres un usuario registrado con nosotros!',
                // tslint:disable-next-line: max-line-length
                '<p class="mt-3 text-center">Ingresa con tu número de identificación y contraseña.</p>',
                'assets/images/backgrounds/Ya_estas_registrado.svg',
                true,
                '/login?product=' + this.sesion.product,
                'Ingresa aquí',
                'modal-confirm',
                undefined,
                true
              );
              break;
            // Se crea por debajo en Okta y se informa que ya existe Creado para que recupere password
            case -605:
              this.modal.open(
                '¡Ya eres un usuario registrado con nosotros!',
                // tslint:disable-next-line: max-line-length
                '<p class="mt-3 text-center">Ya eres un usuario registrado con nosotros, el correo que tenemos vinculado a tu cuenta es: <br><br> <span class="link">' + error.error.message[0] + '</span><br><br>Si no recuerdas tu contraseña, te invitamos a recuperarla a continuación.</p>',
                'assets/images/backgrounds/Ya_estas_registrado.svg',
                true,
                '/recovery?product=' + this.sesion.product,
                'Recuperar contraseña',
                'modal-confirm',
                undefined,
                true
              );
              break;
            // El correo con el que se esta intentando registrar ya se encuentra registrado – posiblemente con otro usuario
            case -604:
              this.modal.open(
                'Otra cuenta ya usa este correo electrónico.',
                // tslint:disable-next-line: max-line-length
                '<p class="mt-3 text-center">La cuenta de correo que estás intentando registrar ya se encuentra en uso, posiblemente por otro usuario.<br> <br> <b>Intenta usando otra cuenta de correo electrónico que no esté vinculada a ningún otro usuario</b></p>',
                'assets/images/backgrounds/Email_en_uso2.svg',
                false,
                "",
                'Entendido',
                'modal-confirm',
                undefined,
                true
              );
              break;
          }
        }
      }
    );
  }



  /*** Llamado al servicio de firstAuthn ***/
  callFirstAuthnEvi(modelo: any) {
    this.loading.open('Proceso validado con éxito', 'En este momento estamos iniciando tu sesión.');
    this.broker.firstAuthn(modelo).subscribe((respuesta2: any) => {
      if (respuesta2.idSession != "") {
        this.sesion.setCookie(respuesta2.idSession);
        this.ingresoNuevoEvidente();
      }
    },
      (error) => {
        this.loading.close();

        $('#errorIniciando').modal('show');
      });
  }

  /*** Secuencia de comandos para iniciar la sesión cuando las credenciales ya fueron validadas ***/
  ingresoNuevoEvidente() {
    // if (this.sesion.product === 'bc') {
    //   if (this.utmCampaign == undefined || this.utmCampaign == '') {
    //     window.location.href = environment.validLogin_bc;
    //   }
    //   else if (this.utmCampaign != '') {
    //     window.location.href = environment.validLogin_bc + 'campaign?utm_campaign=' + this.utmCampaign;
    //   }
    // }
    // if (this.sesion.product === 'midc') {
    //   if (this.sesion.redirect) {
    //     this.sesion.deleteCookieServices('REDIRECT', environment.domain);
    //     window.location.href = environment.validLogin_midc + this.sesion.redirect;
    //   } else {
    //     window.location.href = environment.validLogin_midc;
    //   }
    // }
    // if (this.sesion.product === 'pntd') {
    //   window.location.href = environment.validLogin_pntd;
    // }
    // if (this.sesion.product === 'vrf') {
    //   window.location.href = environment.validLogin_vrf;
    // }
    // if (this.sesion.product === 'os') {
    //   this.router.navigate(['/oneshot/payments'], { queryParams: {product : this.sesion.product} });
    // }
    if (this.sesion.product === 'os') {
      this.router.navigate(['/oneshot/payments'], { queryParams: { product: this.sesion.product } });
    } else {
      if (this.sesion.redirect) {
        this.sesion.deleteCookieServices('REDIRECT', environment.domain);
        window.location.href = this.utilities.getUrlProduct(this.sesion.product) + this.sesion.redirect;
      } else {
        window.location.href = this.utilities.getUrlProduct(this.sesion.product);
      }
    }
  }

  /*** Función que redirige al login si el registro fue exitoso. ***/
  irLogin() {
    this.router.navigate(['/login'], { queryParams: { product: this.sesion.product } });
  }
}